var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_18622)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5278_18622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2755 16.9502C19.0252 15.9857 20.6141 15.0831 22.2339 14.2423C22.4626 14.1248 22.8954 14.2113 23.1427 14.3597C26.9387 16.6411 30.7286 18.9348 34.4999 21.2655C34.7781 21.4387 35.0316 21.9023 35.0378 22.2362C35.0748 26.8298 35.0748 31.4233 35.0378 36.0107C35.0378 36.3631 34.7286 36.8639 34.4195 37.037C30.4875 39.2318 26.5307 41.3895 22.5615 43.5162C22.2462 43.6832 21.6713 43.6955 21.3745 43.5162C17.5414 41.2164 13.733 38.8856 9.93694 36.5239C9.6711 36.3569 9.3867 35.9674 9.38052 35.6769C9.33106 33.8778 9.35579 32.0725 9.35579 30.1003C9.78856 30.3352 10.1101 30.4898 10.413 30.6753C14.1039 32.9195 17.801 35.1514 21.4672 37.4265C22.0608 37.7913 22.4935 37.8036 23.0932 37.4636C25.1149 36.3137 27.1551 35.1946 29.2139 34.1127C29.8568 33.7727 30.1351 33.3894 30.1227 32.6289C30.0671 30.3352 30.0794 28.0353 30.1227 25.7416C30.1351 25.043 29.8816 24.6535 29.3004 24.3073C25.7641 22.1805 22.2401 20.0167 18.716 17.8652C18.2771 17.5993 17.8505 17.3149 17.2879 16.9564L17.2755 16.9502Z",
    fill: "#1D235B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9821 28.2099C25.2757 29.1496 23.6806 30.0646 22.0546 30.8993C21.8012 31.0291 21.3189 30.9178 21.0469 30.7509C17.3498 28.5252 13.6589 26.281 9.99266 23.9996C9.68353 23.808 9.38678 23.3257 9.38059 22.9733C9.31259 18.4169 9.32495 13.8604 9.27549 9.3039C9.26931 8.63002 9.54752 8.30235 10.0978 8.00559C13.9309 5.93446 17.7517 3.84479 21.5601 1.73038C22.1165 1.42126 22.5307 1.41508 23.0933 1.7613C26.8337 4.07354 30.605 6.32396 34.333 8.64238C34.6854 8.86495 35.0069 9.43374 35.0255 9.85414C35.1058 11.5729 35.0564 13.2978 35.0564 15.2329C33.2758 14.1571 31.6437 13.1803 30.0238 12.1911C27.6189 10.7259 25.2015 9.27917 22.8151 7.77684C22.2278 7.40589 21.7703 7.39352 21.1706 7.73356C19.1489 8.8835 17.1087 10.0025 15.0499 11.0845C14.4379 11.4059 14.2029 11.7954 14.2153 12.4941C14.2586 14.8248 14.2586 17.1618 14.2153 19.4988C14.2029 20.1974 14.4564 20.5807 15.0375 20.9269C18.4812 22.9919 21.9063 25.0939 25.3375 27.1898C25.8507 27.4989 26.3576 27.8142 26.9759 28.1975L26.9821 28.2099Z",
    fill: "#1D235B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_18622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5278_18622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7932,
    height: 42.1397,
    fill: "white",
    transform: "translate(9.27539 1.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinstore);
export default __webpack_public_path__ + "static/media/coinstore.e408350ee0ef092545ef38b4a9f98c2f.svg";
export { ForwardRef as ReactComponent };